import { createSlice } from '@reduxjs/toolkit'
const messagesSlice = createSlice({
    name: 'messages',
    initialState: {
        messages: []
    }
    ,
    reducers: {
        messages: (state, action) => {
            state.messages = action.payload;
        }
    }
})

export const {messages} = messagesSlice.actions;
export default messagesSlice.reducer;
